"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.id = exports.uuid = void 0;
var data_1 = require("./data");
var uuid_1 = require("uuid");
exports.uuid = TypedUuid('uuid');
function id(tag) {
    var realTag = "id/" + tag;
    return TypedUuid(realTag, tag);
}
exports.id = id;
var into_u8s = function (_) {
    var length = _.length;
    if (length <= 22 && length >= 16) {
        return decode64(_);
    }
    else if (length === 36) {
        return parseUuidV4(_, new Uint8Array(16));
    }
    throw new Error('Cannot deserialize to id: ' + _);
};
function TypedUuid(tag, trim) {
    if (trim === void 0) { trim = tag; }
    var id = /** @class */ (function (_super) {
        __extends(id, _super);
        function id(bytes) {
            var _this = _super.call(this) || this;
            _this.bytes = bytes;
            if (bytes.length !== 16) {
                throw new TypeError('Malformed UUID input, bytes must be length 16');
            }
            return _this;
        }
        Object.defineProperty(id.prototype, "v4", {
            get: function () {
                return this.memoizedV4();
            },
            enumerable: false,
            configurable: true
        });
        id.prototype.toV4 = function () {
            return this.memoizedV4();
        };
        id.prototype.memoizedV4 = function () {
            var val = this.__v4;
            if (val) {
                return val;
            }
            else {
                val = unparseUuidToV4(this.bytes);
                this.__v4 = val;
                return val;
            }
        };
        id.prototype.memoizedTrim = function () {
            var val = this.__str;
            if (val) {
                return val;
            }
            else {
                val = encode64(this.bytes);
                this.__str = val;
                return val;
            }
        };
        Object.defineProperty(id.prototype, "arrayBuffer", {
            // usable anywhere (?)
            get: function () { return this.bytes.buffer; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(id.prototype, "buffer", {
            // only usable in environments that support Buffer (node only?)
            get: function () { return Buffer.from(this.arrayBuffer, 0, 16); },
            enumerable: false,
            configurable: true
        });
        id.prototype.equals = function (other) {
            if (!id.is(other)) {
                return false;
            }
            var bytes = this.bytes;
            var obytes = other.bytes;
            for (var i = 0; i < 16; i++) {
                if (bytes[i] !== obytes[i]) {
                    return false;
                }
            }
            return true;
        };
        id.prototype.bytesEquals = function (u8s) {
            return id.bytesEqual(this.bytes)(u8s);
        };
        // For value equality semantics in Immutable.js
        // It looks like v4 (coming soon?) might have a better option for this, revisit then
        id.prototype.hashCode = function () {
            var hash = 0, chr;
            var bytes = this.bytes;
            for (var i = 0; i < 16; i++) {
                chr = bytes[i];
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        };
        id.prototype.toString = function () {
            return "[" + trim + " " + this.memoizedV4() + "]";
        };
        Object.defineProperty(id.prototype, "str", {
            get: function () {
                return this.memoizedTrim();
            },
            enumerable: false,
            configurable: true
        });
        id.dataType = tag;
        id.preds = { bytes: function (_) { return _ instanceof Uint8Array && _.length === 16; } };
        id.random = function () { return new id(randomUint8ArrayUuid()); };
        id.rand = id.random;
        id.gen = id.random;
        id.generate = id.random;
        id.bytesEqual = function (a) { return function (b) {
            if (a.length !== b.length) {
                return false;
            }
            for (var i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) {
                    return false;
                }
            }
            return true;
        }; };
        id.fromBuffer = function (b) {
            var u8s = new Uint8Array(16);
            b.copy(u8s, 0, 0, 16);
            return new id(u8s);
        };
        id.is = function (_) { return _ instanceof id; };
        id.serialize = function (_) { return _.str; };
        id.deserialize = function (_) { return new id(into_u8s(_)); };
        id.fromStr = function (_) {
            try {
                return id.deserialize(_);
            }
            catch (err) {
                return undefined;
            }
        };
        id.cache = data_1.Cache.Keyed(function (_) { return _.str; });
        id.compare = function (a, b) {
            var abyte = a.bytes;
            var bbyte = b.bytes;
            for (var i = 0; i < 16; i++) {
                var ai = abyte[i];
                var bi = bbyte[i];
                if (ai > bi) {
                    return 1;
                }
                if (ai < bi) {
                    return -1;
                }
            }
            return 0;
        };
        return id;
    }(data_1.Data));
    var inspect = lookupInspectSymbol();
    if (inspect) {
        id.prototype[inspect] = function () {
            return this.toString();
        };
    }
    id.register();
    return id;
}
//
// December 2017: We cannot use react-native-uuid, so we are using uuid, but
// have to backfill some to-string and from-string functionality
//
// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
}
function parseUuidV4(str, u8s) {
    var i = 0, ii = 0;
    str.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
        if (ii < 16) { // Don't overflow!
            u8s[i + ii++] = _hexToByte[oct];
        }
        return undefined;
    });
    // Zero out remaining bytes if string was short
    while (ii < 16) {
        u8s[i + ii++] = 0;
    }
    return u8s;
}
function unparseUuidToV4(bytes) {
    var bth = _byteToHex;
    var i = 0;
    return bth[bytes[i++]] + bth[bytes[i++]] +
        bth[bytes[i++]] + bth[bytes[i++]] + '-' +
        bth[bytes[i++]] + bth[bytes[i++]] + '-' +
        bth[bytes[i++]] + bth[bytes[i++]] + '-' +
        bth[bytes[i++]] + bth[bytes[i++]] + '-' +
        bth[bytes[i++]] + bth[bytes[i++]] +
        bth[bytes[i++]] + bth[bytes[i++]] +
        bth[bytes[i++]] + bth[bytes[i++]];
}
function randomUint8ArrayUuid() {
    return uuid_1.v4(null, new Uint8Array(16));
}
// chars rationale at https://github.com/dominictarr/d64
var chars = '~0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
var base = chars.length;
var legacyLeader = '.';
var leader = chars.charAt(0);
// Before June 2019, we used this set of chars:
// const chars = '.0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz'
// We replaced `.` with `~`, populating char_map with this is to ensure we can still
// decode strings in the legacy format
var char_map = (_a = {},
    _a[legacyLeader] = 0,
    _a);
for (var i = 0; i < chars.length; i++) {
    var char = chars.charAt(i);
    char_map[char] = i;
}
// Inspired by npm 'base-x', but cannot include because of node dependency
function encode64(source) {
    if (source.length === 0) {
        return '';
    }
    var digits = [0];
    for (var i = 0; i < source.length; ++i) {
        var carry = source[i];
        for (var j = 0; j < digits.length; ++j) {
            carry += digits[j] << 8;
            digits[j] = carry % base;
            carry = (carry / base) | 0;
        }
        while (carry > 0) {
            digits.push(carry % base);
            carry = (carry / base) | 0;
        }
    }
    var str = '';
    // deal with leading zeros
    for (var k = 0; source[k] === 0 && k < source.length - 1; ++k) {
        str += chars[0];
    }
    // convert digits to a string
    for (var q = digits.length - 1; q >= 0; --q) {
        str += chars[digits[q]];
    }
    return str;
}
function decode64(str) {
    if (str.length === 0) {
        return new Uint8Array(16);
    }
    var bytes = [];
    for (var i = 0; i < str.length; i++) {
        var carry = char_map[str[i]];
        if (carry === undefined) {
            throw new Error('invalid base64 encoding');
        }
        for (var j = 0; j < bytes.length; ++j) {
            carry += bytes[j] * base;
            bytes[j] = carry & 0xff;
            carry >>= 8;
        }
        while (carry > 0) {
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    // deal with leading zeros
    for (var k = 0; (str[k] === leader || str[k] === legacyLeader) && k < str.length; ++k) {
        bytes.push(0);
    }
    return new Uint8Array(bytes.reverse());
}
function lookupInspectSymbol() {
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
        return Symbol.for('nodejs.util.inspect.custom');
    }
    return undefined;
}
//# sourceMappingURL=uuid.js.map